import { GlobalSettings } from "@/models/global.model";
import { AnswserQuestion } from "@/models/questions.model";
import { Settings, TypeOfContainement } from "@/models/settings.model";
import {
  calculateContainementType,
  calculateMinimalRenewalRate,
  calculateSiteLevel,
} from "@/services/site.service";
import store from "@/store";
import { SEND_JSON_STATISTICS, UPDATE_SETTINGS } from "@/store/operators";
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  estimedLeakRate,
  isLeakRatePrecise,
  isOutsideOfDeviation,
} from "@/services/settings.service";
import { maxValue, minValue, required } from "@vuelidate/validators";
import { useVuelidate, Validation } from "@vuelidate/core";
import { computed, reactive } from "@vue/composition-api";
import { abacaEvent, getEventJsonData } from "@/services/statistics.service";

@Component({
  setup() {
    // settings
    const settings: Settings = reactive({
      ...store.state.settingsModule.settings,
      answers: store.state.settingsModule.settings.answers.map((answer: AnswserQuestion) => {
        return { ...answer };
      }),
    });
    const globalSettings: GlobalSettings = store.state.globalAppDataModule.settings;

    //computed values
    function depressionToMaintainMinimumLimit(): number {
      return settings.minimalDepressionValue > globalSettings.minimumDepression
        ? settings.minimalDepressionValue
        : globalSettings.minimumDepression;
    }

    // validation rules
    const rule = computed(() => ({
      dustLevel: {
        required,
        minValue: minValue(globalSettings.dustLevelMin),
        maxValue: maxValue(globalSettings.dustLevelMax),
      },
      renewalRate: {
        required,
        minValue: minValue(
          settings.minimumRenewalRate > globalSettings.minimumRenewalRate
            ? settings.minimumRenewalRate
            : globalSettings.minimumRenewalRate
        ),
        maxValue: maxValue(globalSettings.maximumRenewalRate),
      },
      minimalDepressionValue: {
        required,
        minValue: minValue(globalSettings.minimumDepression),
        maxValue: maxValue(settings.depressionValuetoMaintain),
      },
      depressionValuetoMaintain: {
        required,
        minValue: minValue(depressionToMaintainMinimumLimit()),
      },
      leakRate: {
        required,
        minValue: minValue(0.1),
        // 20220915 ABACA-105 : modif du calcul demandee par Eric
        maxValue: maxValue(settings.renewalRate / 1),
         // maxValue: maxValue(settings.renewalRate / 2),

      },
    }));
    return { v: useVuelidate(rule, settings), settings: settings };
  },
})
export default class SettingsComponent extends Vue {
  scolamianteLink = this.$t("components.settingsPage.renewalRateSection.dustLevel.link.href");
  Question2 = "Question_2";
  Question3 = "Question_3";
  settings!: Settings;
  v!: Validation;
  tooltipHelpRenewalRateSection = this.$sanitize(
    this.$t("help.settingsPage.renewalRateSection").toString()
  );
  tooltipHelpDepressionsSection = this.$sanitize(
    this.$t("help.settingsPage.depressionsSection").toString()
  );
  tooltipHelpTypeOfContainementSection = this.$sanitize(
    this.$t("help.settingsPage.typeOfContainementSection").toString()
  );
  tooltipHelpLeakRateSection = this.$sanitize(
    this.$t("help.settingsPage.leakRateSection").toString()
  );

  @Prop() bus!: Vue;
  get globalSettings(): GlobalSettings {
    return store.state.globalAppDataModule.settings;
  }

  mounted(): void {
    this.showQuestionConfinement;
    //init site params
    this.updateSiteParams(this.settings.dustLevel);

    this.bus.$on("validate", this.validate.bind(this));

    store.dispatch(SEND_JSON_STATISTICS, getEventJsonData(abacaEvent.SETTINGS));
  }

  /**
   * Estimate leak rate according to total volume and containment type
   */
  estimateLeakRate(): void {
    this.settings.estimedLeakRate = parseFloat(
      estimedLeakRate(store.state.siteModule.site.totalVolume, this.containmentType).toFixed(1)
    );
    this.settings.isLeakRatePrecise = isLeakRatePrecise(
      store.state.siteModule.site.totalVolume,
      this.containmentType
    );
    this.settings.leakRate = Number(this.settings.estimedLeakRate.toFixed(1));
  }

  /**
   * Calculate site level and minimRenewalRate according to dustLevel
   */
  updateSiteParams(value: number): void {
    this.settings.siteLevel = calculateSiteLevel(value);
    this.settings.minimumRenewalRate = calculateMinimalRenewalRate(value);
    if (this.settings.renewalRate < this.settings.minimumRenewalRate) {
      this.settings.renewalRate = this.settings.minimumRenewalRate;
    }
  }

  // calculate containement type and return it
  get containmentType(): TypeOfContainement {
    return calculateContainementType(this.settings.answers);
  }

  // check if leakRate value is outside of acceptable deviation
  get leakRateWarning(): boolean {
    return isOutsideOfDeviation(
      this.settings.leakRate,
      this.settings.estimedLeakRate,
      this.globalSettings.maximumLeakageRateDeviation
    );
  }

  // validate step and send it to store
  validate(): void {
    this.settings.typeOfContainement = this.containmentType;
    store.commit(UPDATE_SETTINGS, this.settings);
  }

  // unsubrcribe all event on destroy
  destroyed(): void {
    this.bus.$off();
  }

  get showQuestionConfinement(): boolean {
    const answers =this.settings.answers;
    let responseShowQuestion3 = false;
    for (let index = 0; index < answers.length; index++) {
      const element = answers[index]["question"];
      if (element["ref"] == this.Question2) {
        if(answers[index].value == false) responseShowQuestion3 = true;
      }
    }
    this.maintenirValueConfinement(responseShowQuestion3);
    return responseShowQuestion3
  }
  maintenirValueConfinement(responseQuestion2: boolean): void {
    const answers =this.settings.answers;
    for (let index = 0; index < answers.length; index++) {
      const element = answers[index]["question"];
      if (responseQuestion2 == false && element["ref"] == this.Question3) answers[index].value = false;
    }
  }
}
